export default __webpack_public_path__ + "static/media/icon_rotate.c12df9d8.svg";